var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProductCatalogEmptyState = function SvgProductCatalogEmptyState(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_628_120840)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247.5,
    height: 247.5,
    transform: "translate(0.25)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.094,
    cy: 237.437,
    rx: 100.547,
    ry: 5.15625,
    fill: "url(#paint0_linear_628_120840)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_628_120840",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.587 59.9739C187.681 55.852 184.277 52.6104 180.067 50.9072L76.495 9.00688C67.3433 5.30455 56.9231 9.72211 53.2208 18.8738L33.7724 66.9478C30.07 76.0995 34.4876 86.5197 43.6393 90.222L147.212 132.122C151.421 133.826 156.122 133.862 160.358 132.226L195.722 118.561C205.353 114.839 209.837 103.755 205.503 94.3834L189.587 59.9739ZM171.28 94.6041C168.982 100.286 171.724 106.755 177.406 109.053C183.087 111.352 189.556 108.609 191.855 102.928C194.153 97.2461 191.411 90.777 185.729 88.4786C180.048 86.1801 173.579 88.9226 171.28 94.6041Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.587 59.9739C187.681 55.852 184.277 52.6104 180.067 50.9072L76.495 9.00688C67.3433 5.30455 56.9231 9.72211 53.2208 18.8738L33.7724 66.9478C30.07 76.0995 34.4876 86.5197 43.6393 90.222L147.212 132.122C151.421 133.826 156.122 133.862 160.358 132.226L195.722 118.561C205.353 114.839 209.837 103.755 205.503 94.3834L189.587 59.9739ZM171.28 94.6041C168.982 100.286 171.724 106.755 177.406 109.053C183.087 111.352 189.556 108.609 191.855 102.928C194.153 97.2461 191.411 90.777 185.729 88.4786C180.048 86.1801 173.579 88.9226 171.28 94.6041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.067 50.9072L179.317 52.7613L180.067 50.9072ZM189.587 59.9739L187.772 60.8135L189.587 59.9739ZM76.495 9.00688L77.2451 7.15285L76.495 9.00688ZM160.358 132.226L159.637 130.36L160.358 132.226ZM195.722 118.561L196.442 120.427L196.442 120.427L195.722 118.561ZM205.503 94.3834L203.688 95.223L205.503 94.3834ZM179.317 52.7613C183.056 54.2738 186.079 57.1528 187.772 60.8135L191.403 59.1343C189.283 54.5513 185.498 50.9469 180.817 49.0532L179.317 52.7613ZM75.745 10.8609L179.317 52.7613L180.817 49.0532L77.2451 7.15285L75.745 10.8609ZM55.0748 19.6238C58.3629 11.4961 67.6172 7.57282 75.745 10.8609L77.2451 7.15285C67.0694 3.03628 55.4833 7.9481 51.3668 18.1237L55.0748 19.6238ZM35.6264 67.6978L55.0748 19.6238L51.3668 18.1237L31.9183 66.1977L35.6264 67.6978ZM44.3893 88.368C36.2616 85.0799 32.3383 75.8256 35.6264 67.6978L31.9183 66.1977C27.8018 76.3734 32.7136 87.9595 42.8892 92.076L44.3893 88.368ZM147.962 130.268L44.3893 88.368L42.8892 92.076L146.462 133.976L147.962 130.268ZM159.637 130.36C155.875 131.814 151.7 131.781 147.962 130.268L146.462 133.976C151.142 135.87 156.369 135.911 161.079 134.091L159.637 130.36ZM195.001 116.695L159.637 130.36L161.079 134.091L196.442 120.427L195.001 116.695ZM203.688 95.223C207.537 103.546 203.555 113.39 195.001 116.695L196.442 120.427C207.152 116.289 212.138 103.964 207.318 93.5438L203.688 95.223ZM187.772 60.8135L203.688 95.223L207.318 93.5438L191.403 59.1343L187.772 60.8135ZM178.156 107.199C173.498 105.315 171.25 100.012 173.134 95.3542L169.426 93.8541C166.713 100.56 169.95 108.194 176.656 110.907L178.156 107.199ZM190.001 102.178C188.116 106.835 182.813 109.083 178.156 107.199L176.656 110.907C183.361 113.62 190.996 110.383 193.709 103.678L190.001 102.178ZM184.979 90.3326C189.637 92.2168 191.885 97.52 190.001 102.178L193.709 103.678C196.421 96.9722 193.185 89.3373 186.479 86.6246L184.979 90.3326ZM173.134 95.3542C175.018 90.6966 180.322 88.4484 184.979 90.3326L186.479 86.6246C179.774 83.9119 172.139 87.1486 169.426 93.8541L173.134 95.3542Z",
    fill: "#EEEEEE",
    mask: "url(#path-2-inside-1_628_120840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.9102,
    y: 30.084,
    width: 42.0525,
    height: 42.0525,
    rx: 6.95146,
    transform: "rotate(22.0259 69.9102 30.084)",
    fill: "#E2EEFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.645,
    y: 49.7979,
    width: 47.8931,
    height: 9.345,
    rx: 4.6725,
    transform: "rotate(22.0259 118.645 49.7979)",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.497,
    y: 65.1761,
    width: 27.2031,
    height: 7.345,
    rx: 3.6725,
    transform: "rotate(22.0259 113.497 65.1761)",
    fill: "#B1D7F8",
    stroke: "#EEEEEE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-2_628_120840",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.744 59.8585C166.035 57.2377 161.467 56.1268 156.969 56.7515L44.8174 72.3256C35.039 73.6835 28.2129 82.7111 29.5708 92.4895L36.8362 144.809C38.194 154.587 47.2217 161.413 57.0001 160.055L169.152 144.481C173.65 143.857 177.742 141.543 180.596 138.011L204.867 107.977C211.357 99.9457 209.712 88.1021 201.28 82.1433L169.744 59.8585ZM171.236 99.4811C172.088 105.618 177.754 109.903 183.891 109.05C190.029 108.198 194.313 102.532 193.461 96.3948C192.608 90.2576 186.942 85.9733 180.805 86.8255C174.668 87.6778 170.384 93.3439 171.236 99.4811Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.744 59.8585C166.035 57.2377 161.467 56.1268 156.969 56.7515L44.8174 72.3256C35.039 73.6835 28.2129 82.7111 29.5708 92.4895L36.8362 144.809C38.194 154.587 47.2217 161.413 57.0001 160.055L169.152 144.481C173.65 143.857 177.742 141.543 180.596 138.011L204.867 107.977C211.357 99.9457 209.712 88.1021 201.28 82.1433L169.744 59.8585ZM171.236 99.4811C172.088 105.618 177.754 109.903 183.891 109.05C190.029 108.198 194.313 102.532 193.461 96.3948C192.608 90.2576 186.942 85.9733 180.805 86.8255C174.668 87.6778 170.384 93.3439 171.236 99.4811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.744 59.8585L170.898 58.2252L170.898 58.2252L169.744 59.8585ZM180.596 138.011L182.152 139.268L180.596 138.011ZM204.867 107.977L203.312 106.72L203.312 106.72L204.867 107.977ZM201.28 82.1433L202.434 80.51L201.28 82.1433ZM157.244 58.7325C161.239 58.1777 165.296 59.1643 168.589 61.4919L170.898 58.2252C166.774 55.3111 161.696 54.076 156.694 54.7705L157.244 58.7325ZM45.0925 74.3066L157.244 58.7325L156.694 54.7705L44.5423 70.3446L45.0925 74.3066ZM31.5518 92.2144C30.3458 83.5301 36.4082 75.5125 45.0925 74.3066L44.5423 70.3446C33.6699 71.8544 26.08 81.8922 27.5898 92.7646L31.5518 92.2144ZM38.8171 144.534L31.5518 92.2144L27.5898 92.7646L34.8552 145.084L38.8171 144.534ZM56.725 158.074C48.0407 159.28 40.0231 153.218 38.8171 144.534L34.8552 145.084C36.365 155.956 46.4028 163.546 57.2752 162.036L56.725 158.074ZM168.877 142.5L56.725 158.074L57.2752 162.036L169.427 146.462L168.877 142.5ZM179.041 136.754C176.506 139.891 172.872 141.946 168.877 142.5L169.427 146.462C174.428 145.768 178.978 143.196 182.152 139.268L179.041 136.754ZM203.312 106.72L179.041 136.754L182.152 139.268L206.423 109.234L203.312 106.72ZM200.126 83.7767C207.615 89.0688 209.075 99.5872 203.312 106.72L206.423 109.234C213.639 100.304 211.81 87.1355 202.434 80.51L200.126 83.7767ZM168.589 61.4919L200.126 83.7767L202.434 80.51L170.898 58.2252L168.589 61.4919ZM183.616 107.069C178.573 107.77 173.917 104.249 173.217 99.206L169.255 99.7562C170.259 106.988 176.935 112.036 184.166 111.031L183.616 107.069ZM191.48 96.6699C192.18 101.713 188.659 106.369 183.616 107.069L184.166 111.031C191.398 110.027 196.446 103.351 195.442 96.1197L191.48 96.6699ZM181.08 88.8065C186.123 88.1062 190.779 91.6268 191.48 96.6699L195.442 96.1197C194.437 88.8884 187.761 83.8404 180.53 84.8445L181.08 88.8065ZM173.217 99.206C172.516 94.1629 176.037 89.5068 181.08 88.8065L180.53 84.8445C173.299 85.8487 168.251 92.5249 169.255 99.7562L173.217 99.206Z",
    fill: "#EEEEEE",
    mask: "url(#path-7-inside-2_628_120840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.8789,
    y: 94.0869,
    width: 42.5144,
    height: 42.5144,
    rx: 6.95146,
    transform: "rotate(-7.90588 49.8789 94.0869)",
    fill: "#E2EEFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.52,
    y: 86.7783,
    width: 48.4192,
    height: 9.44765,
    rx: 4.72382,
    transform: "rotate(-7.90588 102.52 86.7783)",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.753,
    y: 102.837,
    width: 27.5239,
    height: 7.44765,
    rx: 3.72382,
    transform: "rotate(-7.90588 105.753 102.837)",
    fill: "#B1D7F8",
    stroke: "#EEEEEE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_628_120840)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-3_628_120840",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.656 72.0481C147.129 71.6864 142.634 73.0614 139.084 75.8937L50.5754 146.511C42.8584 152.668 41.5938 163.915 47.7508 171.632L80.694 212.922C86.851 220.639 98.0981 221.903 105.815 215.746L194.324 145.129C197.874 142.297 200.213 138.219 200.865 133.725L206.415 95.5106C207.899 85.2923 200.441 75.9455 190.149 75.1233L151.656 72.0481ZM173.158 105.366C177.022 110.209 184.081 111.003 188.925 107.138C193.768 103.274 194.562 96.215 190.697 91.3716C186.833 86.5282 179.774 85.7345 174.931 89.5988C170.087 93.4632 169.293 100.522 173.158 105.366Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.656 72.0481C147.129 71.6864 142.634 73.0614 139.084 75.8937L50.5754 146.511C42.8584 152.668 41.5938 163.915 47.7508 171.632L80.694 212.922C86.851 220.639 98.0981 221.903 105.815 215.746L194.324 145.129C197.874 142.297 200.213 138.219 200.865 133.725L206.415 95.5106C207.899 85.2923 200.441 75.9455 190.149 75.1233L151.656 72.0481ZM173.158 105.366C177.022 110.209 184.081 111.003 188.925 107.138C193.768 103.274 194.562 96.215 190.697 91.3716C186.833 86.5282 179.774 85.7345 174.931 89.5988C170.087 93.4632 169.293 100.522 173.158 105.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.656 72.0481L151.815 70.0545L151.815 70.0545L151.656 72.0481ZM47.7508 171.632L49.3142 170.385L47.7508 171.632ZM80.694 212.922L79.1307 214.169L80.694 212.922ZM200.865 133.725L202.844 134.013L200.865 133.725ZM206.415 95.5106L208.394 95.798L208.394 95.798L206.415 95.5106ZM190.149 75.1233L189.989 77.1169L189.989 77.1169L190.149 75.1233ZM140.331 77.4571C143.484 74.9417 147.476 73.7206 151.497 74.0418L151.815 70.0545C146.782 69.6523 141.784 71.1811 137.837 74.3304L140.331 77.4571ZM51.8227 148.074L140.331 77.4571L137.837 74.3304L49.328 144.947L51.8227 148.074ZM49.3142 170.385C43.8461 163.531 44.9692 153.542 51.8227 148.074L49.328 144.947C40.7477 151.793 39.3416 164.299 46.1875 172.879L49.3142 170.385ZM82.2574 211.674L49.3142 170.385L46.1875 172.879L79.1307 214.169L82.2574 211.674ZM104.568 214.183C97.7142 219.651 87.7255 218.528 82.2574 211.674L79.1307 214.169C85.9766 222.749 98.482 224.155 107.062 217.31L104.568 214.183ZM193.076 143.566L104.568 214.183L107.062 217.31L195.571 146.692L193.076 143.566ZM198.886 133.438C198.306 137.429 196.229 141.05 193.076 143.566L195.571 146.692C199.518 143.543 202.119 139.01 202.844 134.013L198.886 133.438ZM204.436 95.2232L198.886 133.438L202.844 134.013L208.394 95.798L204.436 95.2232ZM189.989 77.1169C199.13 77.8472 205.753 86.1482 204.436 95.2232L208.394 95.798C210.044 84.4365 201.752 74.0439 190.308 73.1296L189.989 77.1169ZM151.497 74.0418L189.989 77.1169L190.308 73.1296L151.815 70.0545L151.497 74.0418ZM187.677 105.575C183.697 108.751 177.897 108.098 174.721 104.118L171.594 106.613C176.148 112.32 184.465 113.255 190.172 108.702L187.677 105.575ZM189.134 92.6189C192.309 96.5989 191.657 102.4 187.677 105.575L190.172 108.702C195.879 104.149 196.814 95.8311 192.261 90.1243L189.134 92.6189ZM176.178 91.1622C180.158 87.9867 185.959 88.6389 189.134 92.6189L192.261 90.1243C187.708 84.4174 179.39 83.4822 173.683 88.0354L176.178 91.1622ZM174.721 104.118C171.546 100.138 172.198 94.3377 176.178 91.1622L173.683 88.0354C167.976 92.5887 167.041 100.906 171.594 106.613L174.721 104.118Z",
    fill: "#EEEEEE",
    mask: "url(#path-12-inside-3_628_120840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0312,
    y: 162.646,
    width: 42.5144,
    height: 42.5144,
    rx: 10,
    transform: "rotate(-38.5848 66.0312 162.646)",
    fill: "#E2EEFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.574,
    y: 129.504,
    width: 48.4192,
    height: 9.44765,
    rx: 4.72382,
    transform: "rotate(-38.5848 107.574 129.504)",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.141,
    y: 141.506,
    width: 29.5239,
    height: 9.44765,
    rx: 4.72382,
    transform: "rotate(-38.5848 117.141 141.506)",
    fill: "#D7E7FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_628_120840",
    x: 28.1066,
    y: 56.2501,
    width: 180.744,
    height: 165.648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.74619,
    dy: -6.74619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.49746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.03125 0 0 0 0 0.3125 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_628_120840"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_628_120840",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_628_120840",
    x1: 21.8984,
    y1: 239.499,
    x2: 206.134,
    y2: 234.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECEFF1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_628_120840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247.5,
    height: 247.5,
    fill: "white",
    transform: "translate(0.25)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProductCatalogEmptyState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "product-catalog-empty-state.6aa67109d6b8aa6f15ef45b763f32011.svg";